<template>
  <div>
    <page-header title="Overview" breadcrumb="Billings & Collections > Overview" />
    <div class="card mt-3" style="padding:0">
      <div class="w-full">

        <div class="flex justify-end w-full px-4 pt-4">
          <div v-if="filterType == 'custom'" class="flex justify-end w-full px-4 pt-0">
            <div class="date-picker flex items-center justify-center">
              <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
              <span class="pr-2 opacity-50"> to </span>
              <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
            </div>
          </div>
          <div>
            <el-dropdown trigger="click" class="h-full w_semi">
              <div class="drp-content">
                <span class="flex items-center w-full">
                  <img src="../icons/CalendarIcon.svg" />
                  <abbr class="vrt_line"></abbr>
                  <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
                </span>
                <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item >
                <!-- <el-dropdown-item @click="filterType = 'MTD'"> -->
                  <button @click="setFilterType('today','Today')">Today</button>
                </el-dropdown-item>
  
                <el-dropdown-item >
                  <button @click="setFilterType('week','This week')">This week</button>
                </el-dropdown-item>
  
                <el-dropdown-item>
                  <button @click="setFilterType('month','This month')">This month</button>
                </el-dropdown-item>
  
                <el-dropdown-item>
                  <button @click="setFilterType('year','This year')">This year</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('all','All time')">All time</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('custom','Custom')">Custom</button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div ><collection-trend :paymentTrend="paymentTrend" /></div>

        <hr>
        
        <!-- <div class="flex flex-wrap border-b-2 border-gray-400 py-3">
          <div class="md:w-6/12 w-full border-r-2 border-gray-400">
            <donut-chart-module header="Payments" :itemsValues="[
              this.corporateCollectionSum,
              this.privateCollectionSum,
            ]" />
            <ChartList :hidepercent="false" path="/billing-collection/all-transaction" :dataList="[
              {
                name: 'private',
                color: '#D72638',
                amount: this.privateCollectionSum,
              },
              {
                name: 'corporate',
                color: '#09B78A',
                amount: this.corporateCollectionSum,
              },
            ]" />
          </div>
          <div  v-if="!$_isDevelopment" class="md:w-6/12 w-full">
            <donut-chart-module :itemsValues="[
              this.corporateReceivableSum,
              this.privateReceivableSum,
            ]" header="Account Receivables" />
            <ChartList :hidepercent="false" path="/billing-collection/all-transaction" :dataList="[
              {
                name: 'private',
                color: '#D72638',
                amount: this.privateReceivableSum,
              },
              {
                name: 'corporate',
                color: '#09B78A',
                amount: this.corporateReceivableSum,
              },
            ]" />
          </div>
        </div> -->

        <div v-if="userAccountType === 'enterprise_partner'" class="flex flex-wrap border-b-2 border-gray-400 py-3">
          <div class="md:w-6/12 w-full border-r-2 border-gray-400">
            <DonutChart header="Payments" :chartsData="paymentsChart" />
            <DonutChartList :entDataList="paymentsChart" />
          </div>
          <div class="md:w-6/12 w-full">
            <DonutChart header="Account Receivables" :chartsData="receivableChart" />
            <DonutChartList :entDataList="receivableChart" />
          </div>
        </div>
 
         <div v-if="userAccountType === 'enterprise_partner'" class="flex flex-wrap border-b-2 border-gray-400 py-3">
          <div class="md:w-6/12 w-full border-r-2 border-gray-400">
            <LargeDonutChart header="Transaction Volumes" :itemsValues="transactionVolume" />
            <ChartList :hidepercent="true" :dataList="transactionVolume" path="/billing-collection/all-transaction" />

          </div>
          <div class="md:w-6/12 w-full">
            <LargeDonutChart header="Quotes" :itemsValues="estimate" />
            <ChartList :hidepercent="true"  :dataList="estimate" path="/billing-collection/all-transaction" />
          </div>
        </div>

        <div v-if="userAccountType === 'solo_operator'" class="flex flex-wrap border-b-2 border-gray-400 py-3">
          <div class="md:w-6/12 w-full border-r-2 border-gray-400">
            <LargeSoloDonutChart header="Payment Method"  :paymentMethod="paymentMethod"  />
            <SoloChartList  :dataList="paymentMethod"  />
          </div>
          <div class="md:w-6/12 w-full">
            <PaymentStatusDonutChart header="Payment Status"  :paymentStatus="paymentStatus" />            
            <SoloChartList  :dataList="paymentStatus"  />
          </div>
        </div>

        <!-- <settlement-trend :settlementTrend="settlementTrend" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import CollectionTrend from "../modules/CollectionTrend.vue";
// import DonutChartModule from "../modules/DonutChartModule.vue";
import LargeDonutChart from "../modules/LargeDonutChart.vue";
import DonutChart from "../modules/_EnterpriseDonutChart.vue";
import LargeSoloDonutChart from "../modules/_LargeDonutChart.vue";
import PaymentStatusDonutChart from "../modules/_PaymentStatusDonutChart.vue";
import ChartList from "../modules/ChartList.vue";
import DonutChartList from "../modules/_EnterpriseChartList.vue";
import SoloChartList from "../modules/_ChartList.vue";
// import SettlementTrend from "../modules/SettlementTrend.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import moment from "moment";
import debounce from "@/utilities/debounce";
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";

export default {
  components: {
    CollectionTrend,
    
    PaymentStatusDonutChart,
    // DonutChartModule,
    DonutChartList,
    ChartList,
    SoloChartList,
    // SettlementTrend,
    PageHeader,
    LargeDonutChart,
    DonutChart,
    LargeSoloDonutChart,
    ArrowDownBlackIcon
  },
  data() {
    return {
      // overview: {},
      filterTitle: 'This month',
      paymentTrend: [],
      paymentMethod: {},
      paymentStatus: {},
      paymentsChart: {},
      receivableChart: {},
      transactionVolume: {},
      estimate: {},
      // collectionTrend: [],
      // settlementTrend: [],
      // response: {},
      startDate: null,
      endDate: null,
      // dateFilter: "custom",
      filterType: "month",
      // collectionArray: [],
      searchQuery: "",
      // colors: ["#FCC210", "#383F51", "#D72638", "#10233E", "#09B78A"],
    };
  },
  mounted() {
    this.getOverview();
    this.getSoloOverview();
  },
  watch: {
     filterType(newVal, oldVal) {
      // If switching away from custom, clear stale dates
      if (oldVal === "custom" && newVal !== "custom") {
        this.startDate = null;
        this.endDate = null;
      }
    },
    payload(){
      this.getOverview();
      this.getSoloOverview();
    },
    "searchQuery": debounce(function(){
      this.getOverview();
       }, 500),
  },
  computed: {
     userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
      payload() {
      const base = { interval: this.filterType };

      if (this.filterType === "custom") {
        // Only include start/end if BOTH are selected
        if (this.startDate && this.endDate) {
          base.startDate = moment(this.startDate).format("YYYY-MM-DD");
          base.endDate = moment(this.endDate).format("YYYY-MM-DD");
        } else {
          return null; // 🚨 invalid payload, block API call
        }
      }

      return base;
    },
   
    soloPayload() {
      const base = { interval: this.filterType };

      if (this.filterType === "custom") {
        if (this.startDate && this.endDate) {
          base.startDate = moment(this.startDate).format("YYYY-MM-DD");
          base.endDate = moment(this.endDate).format("YYYY-MM-DD");
        } else {
          return null;
        }
      }

      return base;
    },

    // corporateReceivableSum() {
    //   return this.response?.receivable?.corporateReceivableSum || 0
    // },
    // privateReceivableSum() {
    //   return this.response?.receivable?.privateReceivableSum || 0
    // },

    // corporateCollectionSum() {
    //   return this.response?.collection?.corporateCollectionSum || 0
    // },
    // privateCollectionSum() {
    //   return this.response?.collection?.privateCollectionSum || 0
    // },
    // transactionVolume() {
     
    //   let transTotalFilter = this.response?.transactionVolume?.routes?.filter((item) => !item.count).sort((a, b) => {
    //     var x = Number(a.amount);
    //     var y = Number(b.amount);
    //     return x > y ? -1 : x < y ? 1 : 0;
    //   })

    //   if(!Array.isArray(transTotalFilter)) return
      
    //   transTotalFilter = (transTotalFilter || []).map((item, index) => {
    //     return { ...item, color: this.colors[index] };
    //   })
    //   console.log("this.response?.transactionVolume", transTotalFilter)
    //   return transTotalFilter
    // },

    //estimate() {
    //  if(!Array.isArray(this.response?.estimateVolume?.estimateVolume)) return

    //   let _estimate = (this.response?.estimateVolume?.estimateVolume || [])
    //    .map((item) => {
    //      return item
    //    })
    //    .sort((a, b) => {
    //      var x = a.amount;
    //      var y = b.amount;
    //      return x > y ? -1 : x < y ? 1 : 0;
    //    })

    //    _estimate = (_estimate || []).map((item, index) => {
    //      return { ...item, color: this.colors[index] };
    //    })

    //    return _estimate
    //},

  },

  methods: {
    setFilterType(val, title){
      this.filterType = val
      this.filterTitle = title
    },
    setSearchQuery(val){
       this.searchQuery = val
    },
    async getOverview() {
       if (!this.payload) {
        // this.generateToast(response.data.message, "error");
        return;
      }
       this.isLoading = true;
      try {
        let response = await this.$_newGetOverview({ ...this.payload, searchQuery: this.searchQuery });
        this.paymentTrend = response.data.paymentTrend;
        this.paymentsChart = response.data.paymentsChart;
        this.receivableChart = response.data.receivableChart;
        this.transactionVolume = response.data.transactionVolume;
        this.estimate = response.data.quotes;
        
        
        // this.response = response.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        // this.loading = false;
      }
    },
      async getSoloOverview() {
       if (!this.soloPayload) {
        // this.generateToast("Please select both start and end dates.", "error");
        return;
      }
       this.isLoading = true;
      try {
        let response = await this.$_getIndependentPartnersOverview( this.soloPayload );
       this.paymentTrend = response.data.paymentTrend;
       this.paymentMethod = response.data.paymentMethodChart;
       this.paymentStatus = response.data.paymentStatusChart 
      //  this.overview = response.data.data;
      //  this.response = response.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>

<style>
hr{
  border: 1px solid #9BA0A7;
  margin-top: 1%;
}
.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>
